/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_EgInputs */

const en_settings_eg = /** @type {(inputs: Settings_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g.`)
};

const he_settings_eg = /** @type {(inputs: Settings_EgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לדוגמה`)
};

/**
* | output |
* | --- |
* | "e.g." |
*
* @param {Settings_EgInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_eg = /** @type {((inputs?: Settings_EgInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_EgInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_eg(inputs)
	return he_settings_eg(inputs)
});